export default "__VITE_ASSET__e83125ce__"